import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyADoAMGu-eDYfwUQAUsnUkdizJoS98Gxw0",
  authDomain: "qubes-ed1b4.firebaseapp.com",
  projectId: "qubes-ed1b4",
  storageBucket: "qubes-ed1b4.firebasestorage.app",
  messagingSenderId: "374847105535",
  appId: "1:374847105535:web:ebfcff15e2fae05e655fca",
  measurementId: "G-Q72YL5Q6EP",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;


